import { render, staticRenderFns } from "./px-matching-interest-tip.vue?vue&type=template&id=06702db2&scoped=true&"
import script from "./px-matching-interest-tip.vue?vue&type=script&lang=ts&"
export * from "./px-matching-interest-tip.vue?vue&type=script&lang=ts&"
import style0 from "./px-matching-interest-tip.vue?vue&type=style&index=0&id=06702db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06702db2",
  null
  
)

export default component.exports